<template>
    <span>
        <el-select :placeholder="placeholder" v-model="svalue" :clearable='clearable' filterable :disabled="disabled">
            <el-option v-for="(item,index) in options" :key="index" :label="bindLabel(item)"  :value="bindValue(item)"></el-option>            
        </el-select>
    </span>
</template>

<script>

export default { 
    data(){
        return{          
            svalue:this.objSelect,
            tindex: ''
        }
    },
    props:{
        clearable:{
            type:Boolean,
            default:true,
        },
        disabled:{
            type:Boolean,
            default:false,
        },
        optionBind:{
            type:Object,
            default:()=>{
                return{
                    label:"value",
                    value:"key",
                    code: 'index'
                }
            }
        }, 
        objSelect: {
            type: String
        },
        options:{
            type: Array,
            required: true
        },
        placeholder:{
            type: String,
        }
    },
    watch: { 
        svalue(newVal, oldVal) {
            //console.log('1--',newVal)
            // if(this.optionBind.code=='agentSalesCode'){
            //     //console.log('tindex',this.tindex)
            //     this.$emit('changeSelct',this.tindex)
            // }else{
                if (newVal !== oldVal) {
                    this.$emit("changeSelct", this.svalue);
                }   
            // }
                    
        },
        objSelect(newVal,oldVal){    
            console.log('2--',newVal,oldVal)     
           if (newVal !== oldVal) {
                this.svalue = newVal;
            }
        }
    },
    methods:{
        bindLabel(item){
            //console.log('options',this.options)
            let tlabel = this.optionBind.label
            // let tcode = this.optionBind.code
            if(tlabel=="agentSalesPhone"||tlabel=="agentSalesName"){
                let tvalue = this.optionBind.value
                // //console.log('tcode',tcode,this.tindex)
                return item[tvalue]+'/'+item[tlabel]
            }else if(tlabel == 'prodName'){
                let tvalue = this.optionBind.value
                //console.log('tvalue',item[tlabel])
                return item[tlabel]
            }
            // else if(tlabel == "agentName"){
            //     if(this.svalue==''){
            //         this.svalue = this.options[0].agentCode
            //     }else {
            //         return item[tlabel]
            //     }
            // }
            else {
                return item[tlabel];
            }
            // //console.log('code',item[tcode])
            
        },
        bindValue(item){
            let tvalue = this.optionBind.value
            if(tvalue=="agentSalesPhone"||tvalue=="agentSalesName"){
                let tlabel = this.optionBind.label
                return item[tvalue]+'/'+item[tlabel]
            }else if(tvalue=="prodCode"){
                let tlabel = this.optionBind.label
                //console.log('tlabel',item[tvalue])
                return item[tvalue]
            }
            // else if(tvalue == 'agentCode'){
            //     if(this.svalue==''){
            //         this.svalue = this.options[0].agentName
            //     }else {
            //         return item[tvalue]
            //     }
            // }
            else {
                return item[tvalue];
            }
            
        }
    }
}
</script>